import React from 'react'
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';

const dialogContentProps = {
  type: DialogType.normal,
  title: 'Missing Subject',
  subText: 'Do you want to send this message without a subject?',
};

export const ErrorDailog = () => {
  return (
    <>
      <Dialog
        dialogContentProps={dialogContentProps}
      >
        <DialogFooter>
          <PrimaryButton text="Send" />
          <DefaultButton text="Don't send" />
        </DialogFooter>
      </Dialog>
    </>
  )
}

export default ErrorDailog;